<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow pb-5">
          <v-card-title primary-title>
            <div class="text-h5">HostNames:</div>
            <v-spacer></v-spacer>
            <v-div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </v-div>           
          </v-card-title>
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else class="mx-4 mt-1">
              <v-card class="neu-glow pa-4 ma-4">
                <v-row>
                  <v-col cols="6" v-for="(i,ii) in items" :key="ii">
                    <v-card class="neu-glow pa-4 mb-3">
                      <v-row class="ma-2">
                        <v-col cols="12" md="6">
                          <v-text-field            
                            counter
                            dense
                            label="HostName"
                            outlined
                            v-model="items[ii].subdomain"
                            persistent-placeholder
                            :readonly="ii==0"
                            :hint="ii==0?'Indirizzo non modificabile':'Ogni modifica ha un costo di 100 €'"
                            :loading="loading_refresh"
                            :suffix="items[ii].domain"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" md="2" class="text-center mt-1">
                          <v-tooltip top v-if="items[ii].requestDate&&items[ii].enabledDate||!items[ii].fees">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon >
                                <v-icon color="success">mdi-check-decagram</v-icon>
                              </v-btn>
                            </template>
                            <span>Attivo</span>
                          </v-tooltip>
                          <v-tooltip v-else-if="items[ii].requestDate&&!items[ii].enabledDate" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon >
                                <v-icon color="warning">mdi-wheel-barrow</v-icon>
                              </v-btn>
                            </template>
                            <span>In Lavorazione</span>
                          </v-tooltip>
                          <v-tooltip v-else-if="!items[ii].requestDate" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" icon >
                                <v-icon color="info">mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Non Attivo</span>
                          </v-tooltip>                   
                        </v-col>
                        <v-col cols="4" md="2" class="d-flex justify-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                              <v-switch
                                v-model="items[ii].active"
                                inset
                                color="info"
                                :label="items[ii].active?'Si':'No'"
                                class="pl-4 mt-1"
                              >
                              </v-switch>                    
                              </div>
                            </template>
                            <span>Attivare?</span>
                          </v-tooltip> 
                        </v-col>
                        <v-col cols="4" md="2" class="d-flex justify-center">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                                <v-switch
                                  v-if="items[ii].fees"
                                  v-model="items[ii].requestDate"
                                  inset
                                  color="info"
                                  :label="items[ii].requestDate?'Si':'No'"
                                  @change="confirmOwnDomain(ii)"
                                  :disabled="!items[ii].technicianName||items[ii].technicianPhone"
                                  class="pl-4 mt-1"
                                >
                                </v-switch>                   
                              </div>
                            </template>
                            <span>Conferma Richiesta Attivazione</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" v-if="items[ii].active&&ii==1">
                          <v-card class="neu-glow pa-4">
                            <v-col cols="12">
                              Cortesemente inserite i seguenti dati:
                            </v-col>
                            <v-col cols="12">
                              <v-text-field             
                                counter
                                dense
                                label="Nome Gestore Dominio"
                                outlined
                                v-model="items[ii].technicianName"
                                persistent-placeholder
                                hide-details
                                :disabled="!items[ii].active||ii!==1"
                                :loading="loading_refresh"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field v-if="items[ii].active&&ii==1"          
                                counter
                                dense
                                label="Telefono Gestore Dominio"
                                outlined
                                v-model="items[ii].technicianPhone"
                                persistent-placeholder
                                :disabled="!items[ii].active||ii!==1"
                                hide-details
                                :loading="loading_refresh"
                              >
                              </v-text-field>
                            </v-col>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="neu-glow pa-4">
                      <v-row class="mx-2">
                        <v-col cols="6">
                          <div class="justify">Ecco gli indirizzi ed i relativi QR-Code che potente utilizzare sul vs. sito o per le vostre campagne pubblicitarie.</div>
                        </v-col>
                        <v-col cols="6">
                          <div class="justify">Tutti i link puntano alla stessa pagina, ma utilizzando ognuno una propria path, vi consentono di conoscere da quale canale arrivano più prenotazioni e quindi di modulare gli investimenti pubblicitari di conseguenza</div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-row class="">
                      <v-col cols="12" md="6" lg="4" offset-lg="4" offset-md="3"  v-if="items[1].active">
                        <v-card class="neu-glow pa-6 ma-3">
                          <v-card-title class="text-h5 mb-3">Scegli Dominio</v-card-title>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <div v-bind="attrs" v-on="on">
                                <v-switch
                                  v-model="slct"
                                  inset
                                  color="info"
                                  :label="slct?items[1].subdomain+items[1].domain:items[0].subdomain+items[0].domain"
                                  class="d-flex justify-center"
                                >
                                </v-switch>                   
                              </div>
                            </template>
                            <span>Scegli Dominio</span>
                          </v-tooltip>
                        </v-card>
                      </v-col>  
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" lg="4" v-for="(c,ci) in channels" :key="ci">
                        <v-card class="neu-glow pa-6 ma-3">
                          <v-card-title>
                            <div class="text-h5"><v-icon :color="c.color" large class="mr-2">{{c.icon}}</v-icon>{{c.name}}</div>
                            <v-spacer></v-spacer>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="copyToClipboard('https://'+items[slct?1:0].subdomain+items[slct?1:0].domain+c.path)" fab small class="neu-glow mr-4" v-bind="attrs" v-on="on">
                                  <v-icon :color="c.color">mdi-content-copy</v-icon>
                                </v-btn>
                              </template>
                              <span>Copia negli Appunti</span>
                            </v-tooltip>
                          </v-card-title>
                          <v-col>                            
                            <template v-if="items[slct?1:0].subdomain&&items[slct?1:0].subdomain.indexOf('.')>0">
                              <div class="py-4 justify-center d-flex" >
                                <qrcode-vue :value="'https://'+items[slct?1:0].subdomain+items[slct?1:0].domain+c.path" size="150" level="H" class="px-3  pt-3 pb-2 white"></qrcode-vue>
                              </div>
                              <div>{{'https://'+items[slct?1:0].subdomain+items[slct?1:0].domain+c.path}}</div>
                            </template>
                            <template v-else>
                              <div class="py-4 justify-center d-flex" >
                                <qrcode-vue :value="'https://'+items[slct?1:0].subdomain+items[slct?1:0].domain+c.path" size="100" level="H" class="px-3  pt-3 pb-2 white"></qrcode-vue>
                              </div>
                              <div>{{'https://'+items[slct?1:0].subdomain+items[slct?1:0].domain+c.path}}</div>
                            </template>
                          </v-col>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>              
          </div>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Hostnames: Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mb-0">
              <v-card class="neu-glow pa-4">
                <v-col md="12" cols="12">
                    <p>
                      l'Hostname è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni ma anche il punto di ingresso all'App:
                    <br />
                      viene utilizzato il nome che avete indicato in fase di registrazione:
                    </p>
                    <p>
                      Ipotizziamo ad esempio, che il vostro locale si chiami <strong>Arcadia</strong> e/o il vostro sito sia <strong>www.arcadia.it</strong>, il sistema vi attribuirà di default il seguente hostname: <strong>arcadia.ibookrestaurant.com</strong>
                    </p>
                    <p>
                      E' disponibile, a fronte di un contributo di configurazione una tantum di 100 €, una soluzione del tipo <strong>booking.arcadia.it</strong> (o <strong>qualsiasicosa.arcadia.it</strong>)
                    </p>
                    <p>In quest caso è necessario che:
                      <ul>
                        <li>
                          Creiate un nuovo hostname e lo denominiate come meglio credete, nell'esempio <strong>booking.arcadia.it</strong>
                        </li>
                        <li>Abilitate lo switch 'Attivare'</li>
                        <li>
                          Se non avete già un dominio, lo registriamo noi a Vostro nome
                          <br />Se invece l'avete già, inseriate il recapito di colui che gestisce il nome a dominio del vostro sito che contatteremo per le necessarie modifiche.
                        </li>
                        <li>Confermate richiesta attivazione</li>                        
                      </ul>
                    <p>
                      Non appena le impostazioni si saranno propagate (il tempo canonico è 24 ore) provvederemo ad apportare le necessarie modifiche di configurazione e l'indirizzo sarà attivo
                    </p>
                    <p>
                      <sup>1</sup>Se non è già utilizzato
                      <br />
                      <sup>2</sup>(dall'anno successivo vi verrà addebitato un canone di 30.00€)
                      </p>
                </v-col>
              </v-card>
            </v-row>
        </v-card>
    </v-dialog>
    <!--
    <v-dialog v-model="dialog_edit" max-width="500" v-if="editedItem">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              {{editedItem.hostname?'Modifica Hostname':'Aggiungi Hostname'}}
            </v-card-title>
            <v-row class="mx-5">
                <v-col cols="12">
                  <v-text-field            
                    counter
                    dense
                    label="Hostname"
                    outlined
                    v-model="editedItem.hostname"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field            
                    counter
                    dense
                    label="Nome Gestore Dominio"
                    outlined
                    v-model="editedItem.technicianName"
                    persistent-placeholder
                    hide-details
                    :disabled="!editedItem.hostname||editedItem.hostname.indexOf('.')<0"
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field            
                    counter
                    dense
                    label="Telefono Gestore Dominio"
                    outlined
                    v-model="editedItem.technicianPhone"
                    persistent-placeholder
                    :disabled="!editedItem.hostname||editedItem.hostname.indexOf('.')<0"
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>                                                                 
            </v-row>
            <v-divider class="my-3"></v-divider>
            <v-card-actions>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="dialog_edit = false">
                    <v-icon color="info">mdi-exit-box</v-icon>
                  </v-btn>
                </template>
                <span>Esci</span>
              </v-tooltip>
              <v-divider></v-divider>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon :loading="loading_update" @click="saveItem('save')">
                    <v-icon color="success">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>                            
            </v-card-actions>
        </v-card>
    </v-dialog>
    -->
    <v-dialog v-model="dialog_confirm" max-width="500" v-if="ii">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Conferma Richiesta
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="confirmActivation(1)">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Conferma</span>
              </v-tooltip>   
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="confirmActivation(0)">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>            
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="items">
              <p>L'attivazione del servizio su vostro sottodominio richiede alcune modifiche sia sul nostro Applicativo che alle impostazioni del vostro dominio ed ha un costo pari a <strong>{{items[ii].fees}}€</strong></p>
              <p>Forniteci i dettagli di chi gestisce il vostro dominio <strong>{{items[1].hostname}}</strong> compilando i relativi campi: Pensiamo noi a contattarli. Il servizio, di norma, viene attivato in 24 ore.</p>
            </v-card-text>
            <!--
            <v-divider class="my-3"></v-divider>
            <v-card-actions>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="confirmActivation(0)">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Esci</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon :loading="loading_update" @click="confirmActivation(1)">
                    <v-icon color="success">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Conferma Attivazione</span>
              </v-tooltip>                            
            </v-card-actions>-->
        </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QrcodeVue from 'qrcode.vue'
//import _ from 'lodash'
export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      page: "Settings",
      loading:false,
      ii:null,
      slct:null,
      snackbar:false,
      snackbar_color:null,
      snackbar_message:null,
      loading_update:false,
      loading_refresh:false,
      dialog_confirm:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_edit:false,
      dialog_instruction:false,
      items:[],
      channels:[{name:'facebook',path:'fb'},{name:'instagram',path:'ig'},{name:'twitter',path:'tw'},{name:'whatsapp',path:'wa'},{name:'youtube',path:'yt'},{name:'google',path:'go'}],
      items_hash:null,
      editedItem:{},
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Hostname',    value: 'hostname',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Attivo',      value: 'active',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Azione',      value: 'actions',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
  },
  methods:
  {
    copyToClipboard(txt)
    {
      navigator.clipboard.writeText(txt);
      this.snackbar_color="success"
      this.snackbar_message ='Copiato negli Appunti';
      this.snackbar = true;
    },
    confirmActivation(i){
      if (i==1)
      {
        this.items[this.ii].requestDate=new Date().toISOString;
        this.items[this.ii].active=i;
        
      }
      else
      {
        this.items[this.ii].requestDate=null;
        this.items[this.ii].active=0;
        this.dialog_confirm=false;
      }
    },
    confirmOwnDomain(i)
    {
      this.ii=i;
      this.dialog_confirm=true;

    },
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"Hostnames","payload":this.editedItem};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },    
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllHostnames_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.items=res.data.payloads.allHostnames;
                      this.channels=res.data.payloads.channels;
                      this.editedItem=this.items[0];
                      this.ii=1;
                      this.items_hash=JSON.stringify(this.items);
                      console.log(315,this.items)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>